import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function GuideManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    profession: '',
    age: '',
    education: '',
    division: '',
    district: '',
    upazila: '',
    union: '',
    village: '',
    range: '',
    station: '',
    bloodGroup: '',
    organization: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    Satkhira: ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    Khulna: ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    Chandpai: ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    Sarankhola: ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  const guides = [{
    photo: '👤',
    name: 'Mostafa Kamal',
    email: 'mostafa@guide.com',
    idNumber: 'GD-001',
    phone: '01712345678',
    organization: 'Sundarban Fisheries Ltd',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Rafiq Ahmed',
    email: 'rafiq@guide.com',
    idNumber: 'GD-002',
    phone: '01812345678',
    organization: 'Bay of Bengal Trading Co.',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Salma Khatun',
    email: 'salma@guide.com',
    idNumber: 'GD-003',
    phone: '01912345678',
    organization: 'Khulna Honey Producers',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Babul Hossain',
    email: 'babul@guide.com',
    idNumber: 'GD-004',
    phone: '01612345678',
    organization: 'Mongla Port Services',
    status: 'pending' as const
  }, {
    photo: '👤',
    name: 'Nasreen Akter',
    email: 'nasreen@guide.com',
    idNumber: 'GD-005',
    phone: '01512345678',
    organization: 'Satkhira Wood Industries',
    status: 'approved' as const
  }];
  const columns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-803">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'organization',
    label: 'Organization'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-804" />
  }];
  const filters = [{
    key: 'organization',
    label: 'Organization',
    options: ['Sundarban Fisheries Ltd', 'Bay of Bengal Trading Co.', 'Khulna Honey Producers', 'Mongla Port Services', 'Satkhira Wood Industries']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter guide personal information'
  }, {
    title: 'Address & Association',
    description: 'Enter address and organization details'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-805">
      <div data-id="element-806">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-807">Guide Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-808">
          Manage registered guides and their associations
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-809">
        <div className="flex gap-4" data-id="element-810">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-811">
            Guide List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-812">
            Add Guide
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={guides} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search guides..." data-id="element-813" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid || !formData.organization) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Guide ${formData.fullName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        profession: '',
        age: '',
        education: '',
        division: '',
        district: '',
        upazila: '',
        union: '',
        village: '',
        range: '',
        station: '',
        bloodGroup: '',
        organization: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-814">
          {currentStep === 0 && <div className="space-y-4" data-id="element-815">
              <div className="grid grid-cols-2 gap-4" data-id="element-816">
                <div data-id="element-817">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-818">
                    Photo Upload
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-819" />
                </div>
                <div data-id="element-820">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-821">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-822" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-823">
                <div data-id="element-824">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-825">
                    Father's Name
                  </label>
                  <input type="text" value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-826" />
                </div>
                <div data-id="element-827">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-828">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-829" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-830">
                <div data-id="element-831">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-832">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-833" />
                </div>
                <div data-id="element-834">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-835">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-836" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-837">
                <div data-id="element-838">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-839">
                    Profession
                  </label>
                  <input type="text" value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-840" />
                </div>
                <div data-id="element-841">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-842">
                    Age
                  </label>
                  <input type="number" value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-843" />
                </div>
                <div data-id="element-844">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-845">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-846" />
                </div>
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-847">
              <div className="grid grid-cols-2 gap-4" data-id="element-848">
                <div data-id="element-849">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-850">
                    Division
                  </label>
                  <select value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-851">
                    <option value="" data-id="element-852">Select Division</option>
                    <option value="Khulna" data-id="element-853">Khulna</option>
                    <option value="Barisal" data-id="element-854">Barisal</option>
                    <option value="Dhaka" data-id="element-855">Dhaka</option>
                    <option value="Chattogram" data-id="element-856">Chattogram</option>
                    <option value="Rajshahi" data-id="element-857">Rajshahi</option>
                    <option value="Rangpur" data-id="element-858">Rangpur</option>
                    <option value="Sylhet" data-id="element-859">Sylhet</option>
                    <option value="Mymensingh" data-id="element-860">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-861">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-862">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-863">
                    <option value="" data-id="element-864">Select District</option>
                    <option value="Satkhira" data-id="element-865">Satkhira</option>
                    <option value="Khulna" data-id="element-866">Khulna</option>
                    <option value="Bagerhat" data-id="element-867">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-868">
                <div data-id="element-869">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-870">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-871">
                    <option value="" data-id="element-872">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-873">Shyamnagar</option>
                    <option value="Koyra" data-id="element-874">Koyra</option>
                    <option value="Dacope" data-id="element-875">Dacope</option>
                    <option value="Mongla" data-id="element-876">Mongla</option>
                    <option value="Sarankhola" data-id="element-877">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-878">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-879">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-880">
                    <option value="" data-id="element-881">Select Union</option>
                    <option value="Burigoalini" data-id="element-882">Burigoalini</option>
                    <option value="Gabura" data-id="element-883">Gabura</option>
                    <option value="Munshiganj" data-id="element-884">Munshiganj</option>
                    <option value="Koyra" data-id="element-885">Koyra</option>
                    <option value="Dacope" data-id="element-886">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-887">
                <div data-id="element-888">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-889">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-890">
                    <option value="" data-id="element-891">Select Village</option>
                    <option value="Munshiganj" data-id="element-892">Munshiganj</option>
                    <option value="Gabura" data-id="element-893">Gabura</option>
                    <option value="Shyamnagar" data-id="element-894">Shyamnagar</option>
                    <option value="Koyra" data-id="element-895">Koyra</option>
                    <option value="Dacope" data-id="element-896">Dacope</option>
                  </select>
                </div>
                <div data-id="element-897">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-898">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-899">
                    <option value="" data-id="element-900">Select Range</option>
                    <option value="Satkhira" data-id="element-901">Satkhira</option>
                    <option value="Khulna" data-id="element-902">Khulna</option>
                    <option value="Chandpai" data-id="element-903">Chandpai</option>
                    <option value="Sarankhola" data-id="element-904">Sarankhola</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-905">
                <div data-id="element-906">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-907">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-908">
                    <option value="" data-id="element-909">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-910">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-911">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-912">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-913">
                    <option value="" data-id="element-914">Select Blood Group</option>
                    <option value="A+" data-id="element-915">A+</option>
                    <option value="A-" data-id="element-916">A-</option>
                    <option value="B+" data-id="element-917">B+</option>
                    <option value="B-" data-id="element-918">B-</option>
                    <option value="AB+" data-id="element-919">AB+</option>
                    <option value="AB-" data-id="element-920">AB-</option>
                    <option value="O+" data-id="element-921">O+</option>
                    <option value="O-" data-id="element-922">O-</option>
                  </select>
                </div>
                <div data-id="element-923">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-924">
                    Organization *
                  </label>
                  <select required value={formData.organization} onChange={e => setFormData({
              ...formData,
              organization: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-925">
                    <option value="" data-id="element-926">Select Organization</option>
                    <option value="Sundarban Fisheries Ltd" data-id="element-927">
                      Sundarban Fisheries Ltd
                    </option>
                    <option value="Bay of Bengal Trading Co." data-id="element-928">
                      Bay of Bengal Trading Co.
                    </option>
                    <option value="Khulna Honey Producers" data-id="element-929">
                      Khulna Honey Producers
                    </option>
                    <option value="Mongla Port Services" data-id="element-930">
                      Mongla Port Services
                    </option>
                    <option value="Satkhira Wood Industries" data-id="element-931">
                      Satkhira Wood Industries
                    </option>
                  </select>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-932">
              <div data-id="element-933">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-934">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-935" />
              </div>
              <div data-id="element-936">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-937">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-938" />
              </div>
              <div data-id="element-939">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-940">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-941" />
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-942">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-943">
                <div className="flex items-center justify-between mb-3" data-id="element-944">
                  <h4 className="font-semibold text-gray-900" data-id="element-945">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-946">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-947">
                  <div data-id="element-948">
                    <span className="text-gray-600" data-id="element-949">Name:</span>{' '}
                    <span className="font-medium" data-id="element-950">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-951">
                    <span className="text-gray-600" data-id="element-952">NID:</span>{' '}
                    <span className="font-medium" data-id="element-953">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-954">
                    <span className="text-gray-600" data-id="element-955">Profession:</span>{' '}
                    <span className="font-medium" data-id="element-956">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-957">
                <div className="flex items-center justify-between mb-3" data-id="element-958">
                  <h4 className="font-semibold text-gray-900" data-id="element-959">
                    Address & Association
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-960">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-961">
                  <div data-id="element-962">
                    <span className="text-gray-600" data-id="element-963">Division:</span>{' '}
                    <span className="font-medium" data-id="element-964">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-965">
                    <span className="text-gray-600" data-id="element-966">District:</span>{' '}
                    <span className="font-medium" data-id="element-967">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-968">
                    <span className="text-gray-600" data-id="element-969">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-970">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-971">
                    <span className="text-gray-600" data-id="element-972">Union:</span>{' '}
                    <span className="font-medium" data-id="element-973">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-974">
                    <span className="text-gray-600" data-id="element-975">Village:</span>{' '}
                    <span className="font-medium" data-id="element-976">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-977">
                    <span className="text-gray-600" data-id="element-978">Range:</span>{' '}
                    <span className="font-medium" data-id="element-979">
                      {formData.range || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-980">
                    <span className="text-gray-600" data-id="element-981">Station:</span>{' '}
                    <span className="font-medium" data-id="element-982">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-983">
                    <span className="text-gray-600" data-id="element-984">Organization:</span>{' '}
                    <span className="font-medium" data-id="element-985">
                      {formData.organization || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}